import ICAL from 'ical.js';

/**
 * Parst einen ICS-String und gibt Events zurück.
 * @param {string} icsContent - Der rohe Inhalt der ICS-Datei
 * @returns {Array} Array von Event-Objekten
 */
export const parseIcsContent = (icsContent) => {
  try {
    const jcalData = ICAL.parse(icsContent);
    const comp = new ICAL.Component(jcalData);
    const vevents = comp.getAllSubcomponents('vevent');

    return vevents.map(event => {
      const vevent = new ICAL.Event(event);
      return {
        uid: vevent.uid,
        title: vevent.summary,
        description: vevent.description,
        start: vevent.startDate.toJSDate(),
        end: vevent.endDate.toJSDate(),
        allDay: vevent.startDate.isDate,
        location: vevent.location
      };
    });
  } catch (error) {
    console.error("Fehler beim Parsen der ICS-Daten:", error);
    throw new Error("Datei konnte nicht gelesen werden. Ist es eine gültige ICS-Datei?");
  }
};

/**
 * Versucht, aus dem Titel den Müll-Typ zu erraten.
 */
export const detectTrashType = (title) => {
  const t = title.toLowerCase();
  if (t.includes('rest') || t.includes('grau') || t.includes('schwarz') || t.includes('hausmüll')) return 'restmüll';
  if (t.includes('bio') || t.includes('braun') || t.includes('grün') || t.includes('kompost')) return 'biomüll';
  if (t.includes('papier') || t.includes('blau') || t.includes('pappe') || t.includes('karton')) return 'papier';
  if (t.includes('gelb') || t.includes('wertstoff') || t.includes('leichtverpackung') || t.includes('plastik')) return 'gelberSack';
  if (t.includes('sperr')) return 'sperrmüll';
  if (t.includes('schadstoff') || t.includes('gift') || t.includes('problem')) return 'schadstoff';
  
  return 'restmüll'; // Fallback
};